import { ChevronDown, MousePointerClick } from "lucide-react";
import type { DayContent } from "../types";
import { getIsraelGreeting } from "../israelTime";

interface Props {
  day: DayContent;
  step: number;
  onAdvance: () => void;
  onContinue: () => void;
}

export function IntroScene({ day, step, onAdvance, onContinue }: Props) {
  const timeGreeting = getIsraelGreeting();
  const greeting = day.number === 10
    ? `${timeGreeting} רבקה היקרה, האהובה והיפה. היום יום ${day.weekday}, ${day.hebrewDate}, ${day.dateLabel}. היום הגדול שלנו הגיע. האישה הכי חזקה ויפה בעולם — אנחנו בדרך לחופה.`
    : `${timeGreeting} רבקה היקרה, האהובה והיפה. היום יום ${day.weekday}, ${day.hebrewDate}, ${day.dateLabel}. ${day.countdownLabel} ליום הגדול שלנו. האישה הכי חזקה ויפה בעולם — את בדרך לשם…`;

  return (
    <section className="intro-scene" aria-label="פתיחת הסיפור">
      <img src="/assets/avi-rivka-intro.jpeg" alt="אבי ורבקה הולכים יחד ומחייכים" />
      <div className="intro-vignette" aria-hidden="true" />
      <button type="button" className="speech speech-avi visible" onClick={onAdvance} disabled={step > 0} aria-label="לחצי על שומעת">
        <span>שומעת?!</span>
        {step === 0 && <small><MousePointerClick aria-hidden="true" /> לחצי כאן</small>}
      </button>
      {step >= 1 && (
        <button type="button" className="speech speech-rivka visible" onClick={onAdvance} aria-label="לחצי על מה היה">
          <span>מה היה…</span>
          <small><MousePointerClick aria-hidden="true" /> לחצי כאן</small>
        </button>
      )}
      {step >= 2 && (
        <div className="greeting-overlay" role="status">
          <p>{greeting}</p>
          <button className="scroll-button" onClick={onContinue} aria-label="המשיכי אל האור">
            <ChevronDown aria-hidden="true" />
          </button>
        </div>
      )}
    </section>
  );
}
